module.exports = __webpack_public_path__ + "static/venues-964755b5ad4181944178907ca6eb56df.jpg";